import { faPhone } from '@awesome.me/kit-5452b20ec3/icons/classic/solid'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import { MDVIP_PHONE, MDVIP_PHONE_HREF } from '../../Constants'
import styles from './Footer.module.scss'

const Footer = () => {
  const currentYear = new Date().getFullYear()

  return (
    <footer className={styles['footer']}>
      <div className={styles['logo-container']}>
        <a
          href="https://www.mdvip.com"
          target="_blank"
          rel="noreferrer noopener"
          title="Link to MDVIP homepage"
          aria-label="MDVIP homepage"
        >
          <svg width="76" height="77" viewBox="0 0 76 77" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M52.8838 53.447V27.5878L39.0606 58.4723H35.9315L19.8986 27.6152V58.434H14.5432V20.3206H25.5419L39.3818 46.9344L51.2666 20.3206H61.5233V55.0438H72.0679V6.54614H3.91547V70.8141H72.079V61.4908H75.9945V74.6801H0V2.68011H76V58.4669H72.7934L57.9789 58.4723C55.171 58.4723 52.8893 56.2194 52.8893 53.447H52.8838Z"
              fill="black"
            />
          </svg>
        </a>
        <div className={styles['phone-container']}>
          <p className={styles['phone-tagline']}>Need Help?</p>
          <div className={styles['phone']}>
            <FontAwesomeIcon className={styles['phone-icon']} icon={faPhone} />
            <a href={MDVIP_PHONE_HREF} rel="noopener noreferrer" aria-label={`Call MDVIP at ${MDVIP_PHONE}`}>
              {MDVIP_PHONE}
            </a>
          </div>
        </div>
      </div>
      <hr className={styles['divider']} />
      <div className={styles['legal-container']}>
        <div className={styles['legal-links']}>
          <a href="https://www.mdvip.com/terms-of-use" rel="noreferrer noopener" target="_blank">
            Terms
          </a>
          <a href="https://www.mdvip.com/privacy-policy" rel="noreferrer noopener" target="_blank">
            Privacy Policy
          </a>
          {/* TrustArc CCM injects the Cookie Preferences link here at runtime (EXP-311) */}
          <div id="teconsent"></div>
        </div>
        <p className={styles['copyright']}>Copyright © {currentYear} MDVIP, All Rights Reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
